// @NOTE: assumes jQuery is included by WP
const $ = jQuery 

class events {
  constructor () { 
    this.$eventFilterDropdown  = $('#event-filter-dropdown');
    this.showUpcomingEvents    = $('body').hasClass('page-template-template-events')

    this.$eventFilterDropdown.on('change', (event) => {
      let selectedTermID = $(event.currentTarget).val() 
      this.eventFilterByCategory(selectedTermID)
    }) 
  }

  eventFilterByCategory (term_id) {
    $.ajax({
      type: 'POST',
      url: window.ajaxUrl,
      data: {
        action: 'get_upcoming_events_by_category_html',
        term_id: term_id,
        upcoming: this.showUpcomingEvents
      },
      beforeSend:() => {
        //$(".overlay_loader_ajax").show()
      },
      success: function(response) { 
        $('.event-listing-container').html(response) 
    },
    fail : function(response) {
      //console.log("Fail");
    }
    });
  }
}

export default events


// WEBPACK FOOTER //
// ./src/js/custom/events/events.js